import type { ReactNode } from 'react'
import React from 'react'

import { ModalBox, useMediaQueryContext, useModalContext } from '@fourthwall/components'

import * as S from './SubscriptionLimitModal.styled'

export type SubscriptionLimitModalProps = {
  title?: string
  content: ReactNode
}

export const SubscriptionLimitModal = ({
  title = 'Limit reached',
  content,
}: SubscriptionLimitModalProps) => {
  const { close } = useModalContext()
  const media = useMediaQueryContext()

  return (
    <ModalBox width={media.tablet ? '480px' : undefined} title={title} onClose={close}>
      <S.Content>{content}</S.Content>
    </ModalBox>
  )
}
